import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import moment from "moment/moment";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import {useLavoratore} from "@commons/hooks/useLavoratoreHR";
import {resetContratto, selectSitePreferences, selectToken, setupContratto} from "@commons/core.slice";
import {FPNet2HRFilter, HR2FPNetFilter} from "./Convertitori";
import {LavoratoreFilterSelection, useGetLavoratoriQuery} from "@commons/features/lavoratore/lavoratore.api";
import {useQueryFilter, useSetIdAzienda, useSetIdAziendaMaster} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";

import * as Buttons from "../../components/dataTable/buttons";
import {changeDomain, updateSitePreferences} from "@commons/actions/environment.action";
import {toast} from "react-toastify";
import Glossario from "./Glossario";
import OptionsBar from "./OptionsBar";
import LavoratoreFilter from "./LavoratoreFilter";
import Toggle from "../../components/Toggle";
import DTTitle from "../../components/dataTable/TableTitle";
import DTTable from "../../components/dataTable/Table";
import classNames from "classnames";
import Pagination from "../../components/dataTable/Pagination";

import {FlyoutTip} from "@components/FlyoutTip";
import {formatDt} from "@commons/utils/util";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {toastAsError} from "@utilities/toastAsError";
import {useFotoLavoratore} from "@hooks/useFotoLavoratore";
import {IconCamera} from "@tabler/icons-react";


/*
* * se lavoratoreSrcFoto viene valorizzato, è prioritario rispetto a quello determinato localmente, vedi più avanti <useFotoLavoratore>
* tale parametro diventa indispensabile nella pagina delle generalità del lavoratore, dove è possibile modificare la relativa foto
* */
interface LavoratoreBarProps {
    azienda: AziendaRecord,
    children?: React.ReactNode;
    lavoratoreSrcFoto?: string | null // Prevedo la possibiltà di gestire esternamente url della foto del lavoratore*
}

export const LavoratoreBar: React.FC<LavoratoreBarProps> = ({azienda, children, lavoratoreSrcFoto}) => {
    const dispatch = useAppDispatch();
    const sitePreferences = useAppSelector(selectSitePreferences);
    const initialFilter = FPNet2HRFilter(sitePreferences.lavoratoriFilter, {tipo: 'flat', tutti: 'all'}) as LavoratoreFilterSelection;

    const [glossario, setGlossario] = useState<string>(initialFilter.iniziale);
    const [qualifiche, setQualifiche] = useState<string[]>(initialFilter.qualifiche);

    const [open, setOpen] = useState<boolean>(false);
    const [filtroAttivo, setFiltroAttivo] = useState<boolean>(initialFilter.tutti !== 'all');

    const pagination = usePagination('', 1, 10);
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;

    const {filter, setFilter, skip} = useQueryFilter<LavoratoreFilterSelection>(initialFilter, pagination);
    useSetIdAziendaMaster(azienda, setFilter);
    useSetIdAzienda(azienda, setFilter);

    /*useEffect(() => {
        dispatch(resetContratto());
    }, [azienda]);*/

    useEffect(() => {
        setFilter(filter => ({
            ...filter, iniziale: glossario
        }));
        setUpdSitePref(false);
    }, [glossario, setFilter]);

    useEffect(() => {
        setFilter(filter => ({
            ...filter, qualifiche: qualifiche
        }));
        setUpdSitePref(false);
    }, [qualifiche, setFilter]);

    useEffect(() => { // SOLO RESET!!!
        if (!filtroAttivo) {
            setFilter(filter => ({
                ...filter, tutti: 'all'
            }));
            setUpdSitePref(false);
        }
    }, [filtroAttivo, setFilter]);

    const skipQuery = skip || !filter.idAziendaMaster || !filter.idAzienda;
    const {data} = useGetLavoratoriQuery(filter, {skip: skipQuery});
    const localData = data;
    const URI = null;

    // Array con gli idDip dei lavoratori per i quali è stato mostrato il dettaglio
    const [opened, setOpened] = useState<number[]>([]);
    // Button per mostrare e nascondere il dettaglio del lavoratore
    const ButtonDetail: React.FC<{ item: LavoratoreRecord }> = ({item}) => {
        return <Buttons.ToggleDetail
            // className={!(item.partitaIvaPromotore || LavoratoreRecord.hasMoreUL(item)) ? 'invisible' : undefined}
            className={!item.partitaIvaPromotore  ? 'invisible' : undefined}

                                     initialState={opened.indexOf(item.id) >= 0}
                                     onToggle={(state) => {
                                         let newVal: number[] = [];
                                         if (state) {
                                             newVal = newVal.concat(opened);
                                             newVal.push(item.id);
                                         } else {
                                             newVal = opened.filter((i) => i !== item.id);
                                         }
                                         setOpened(newVal);
                                     }}/>
    }

    function isCessato(item: LavoratoreRecord): boolean {
        const cessato = item.dataCessazione && moment(item.dataCessazione, 'YYYY-MM-DD').isBefore(moment()) ? true : false;
        return cessato;
    }

    function onSubmit(formData: Partial<LavoratoreFilterSelection>) {
        setOpen(false);
        setFiltroAttivo(true);
        setFilter(filter => ({
            ...filter, ...formData, tutti: null
        }));
        setUpdSitePref(false);
    }

    const token: TokenRecord | null = useAppSelector(selectToken);

    function updSitePreferences(filter: LavoratoreFilterSelection) {
        const lavoratoriFilter = HR2FPNetFilter(filter, sitePreferences.lavoratoriFilter);
        dispatch(updateSitePreferences({token: token!.token, pref: {...sitePreferences, lavoratoriFilter: lavoratoriFilter}})).then((r) => {
            if (r.type === changeDomain.rejected.type)
                toast("ERRORE nel modificare il dominio!", {type: 'error'})
        });
    }

    const [updSitePref, setUpdSitePref] = useState<boolean>(false);

    // Aggiorno site-preferences con un ritardo di 5" all'occorenza
    useEffect(() => {
        if (!updSitePref) {
            setUpdSitePref((v) => !v);
            setTimeout(() => {
                // TODO sistemare chiamata a upd site-preferences!!!
                //updSitePreferences(filter);
            }, 5000)
        }
    }, [filter]);

    //const contratto = useAppSelector(selectLavoratore);
    const contratto: LavoratoreRecord | null = useLavoratore(toastAsError);

    const fotoHook = useFotoLavoratore(contratto);
    let srcFoto;
    if (lavoratoreSrcFoto)
        srcFoto = lavoratoreSrcFoto;
    else
        srcFoto = fotoHook.srcFoto;

    const reset = () => {
        dispatch(resetContratto())
    }
    // Per mostrare e nascondere i dettagli del lavoratore è necessarrio generare una seconda riga per ciascuno di essi:
    // per farlo ho restituito un array, vedi...
    // https://reactjs.org/blog/2017/09/26/react-v16.0.html#new-render-return-types-fragments-and-strings
    // ${srcFoto ? '' : '!mb-5'}
    return <>
        {/* CON LAVORATORE/CONTRATTO SELEZIONATO */}
        {contratto &&
            <div>
                <div className="w-full
                            flex flex-col md:flex-row
                            rounded-lg bg-green-200
                            px-4 xl:px-6 py-2  mt-4 mb-2
                            font-medium text-green-700 text-xs xl:text-sm
                            focus:outline-none focus-visible:ring focus-visible:ring-green-500 focus-visible:ring-opacity-75">

                    <div className="md:mr-auto my-auto">
                        <div className="flex flex-row justify-center items-center">
                        <span className="md:hidden truncate uppercase">
                            {contratto.cognome} {contratto.nome}
                        </span>

                            <span className="max-md:hidden truncate">
                            Hai selezionato il lavoratore&nbsp;&nbsp;<span className="uppercase">{contratto.cognome} {contratto.nome}</span>&nbsp;&nbsp;[Contratto #{contratto.id}]
                        </span>

                            {srcFoto &&
                                <FlyoutTip className="bg-blue-800 rounded-lg align-middle ml-3 max-md:mb-1" button={
                                    <IconCamera className="h-5 w-5 m-0.5 text-white place-self-center"/>
                                }>
                                    <img src={srcFoto} className="mt-1 shadow-sm border border-gray-200 max-w-[120px]"/>
                                </FlyoutTip>
                            }
                        </div>
                    </div>
                    <div className="self-center md:ml-auto">
                        <button className="md:w-64 rounded-lg bg-green-700 py-1 px-1.5 text-white shadow-sm hover:bg-green-600" onClick={reset}>
                            CAMBIA LAVORATORE/CONTRATTO
                        </button>
                    </div>
                </div>

                <div>{children}</div>
            </div>
        }


        {/* SENZA LAVORATORE/CONTRATTO SELEZIONATO */}
        {!contratto && <>
            <div className="w-full text-xs mt-4 max-sm:hidden">Glossario e filtro qualifiche:</div>
            <div className="w-full text-xs mt-4 max-sm:show min-[640px]:hidden">Filtro qualifiche :</div>

            <div className="w-full inline-flex mb-3 max-[1170px]:flex max-[1170px]:flex-col max-[1170px]:flex-wrap">
                <Glossario value={glossario} setValue={setGlossario}/>
                <OptionsBar value={qualifiche} setValue={setQualifiche}/>
            </div>

            <LavoratoreFilter filter={filter} onSubmit={onSubmit} open={open} setOpen={setOpen} onReset={() => setFiltroAttivo(false)}>
                <div className="inline-flex items-center max-sm:text-left">
                    <Toggle auxState={filtroAttivo} initialState={filtroAttivo} onChange={(newState) => {
                        setFiltroAttivo(newState);
                        setOpen(newState);
                    }} indeterminate={open} className="mr-3"/>

                    Filtro lavoratori per data assunzione e data cessazione
                </div>

            </LavoratoreFilter>

            <DTTitle id="elencoLavoratori" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

            <DTTable<LavoratoreRecord> dtSchema={localData}
                                       header={<>
                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                               Cod.Fiscale
                                           </th>
                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                               Nominativo
                                           </th>
                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                               Qualifica
                                           </th>
                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                               Dt. ass.
                                           </th>
                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                               Dt. fine T.DET.
                                           </th>
                                           <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                               Dt. cess.
                                           </th>
                                           <th scope="col" className="py-3.5 w-20"/>
                                       </>}

                                       rows={({item, index, isMobile, currentRow, register}) => (
                                           [
                                               <tr {...register(item.id!, index, item.URI === URI,
                                                   classNames('text-gray-500',
                                                       item.partitaIvaPromotore && '!text-orange-400',
                                                       LavoratoreRecord.hasMoreUL(item) && '!text-blue-500',
                                                   )
                                               )}>
                                                   <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${isCessato(item) ? 'line-through' : undefined}`}>
                                                       {item.codiceFiscale}
                                                   </td>
                                                   <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${isCessato(item) ? 'line-through' : undefined}`}>
                                                       {item.descrizione}
                                                   </td>
                                                   <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${isCessato(item) ? 'line-through' : undefined}`}>
                                                       {item.qualifica}
                                                   </td>
                                                   <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${isCessato(item) ? 'line-through' : undefined}`}>
                                                       {formatDt(item.dataAssunzione)}
                                                   </td>
                                                   <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${isCessato(item) ? 'line-through' : undefined}`}>
                                                       {formatDt(item.dataFineTDET)}
                                                   </td>
                                                   <td className={`whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium sm:pl-6 ${isCessato(item) ? 'line-through' : undefined}`}>
                                                       {formatDt(item.dataCessazione)}
                                                   </td>
                                                   <td className="whitespace-nowrap py-2 text-sm font-medium">
                                                       <Buttons.Visibility visible={isMobile || index === currentRow}>
                                                           <Buttons.GO onAction={() => dispatch(setupContratto(item))}/>
                                                           <ButtonDetail item={item}/>
                                                       </Buttons.Visibility>
                                                   </td>
                                               </tr>,
                                               <tr {...register('detail_' + item.id!, index, item.URI === URI)}>
                                                   {opened.indexOf(item.id) >= 0 && [
                                                       <td key={'td1_detail_' + item.id} colSpan={6}
                                                           className="whitespace-nowrap pb-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                                                           {item.partitaIvaPromotore && <ul className="ml-4 list-disc">
                                                               <li>
                                                                   Soggetto promotore/somministrante: {item.denominazionePromotore}
                                                               </li>
                                                           </ul>}

                                                           {/* TODO: SERVE LAVORATORE DI TIPO <LavoratoreExRecord> PER POTER RISALIRE ALLE UL!!
                                                           {LavoratoreRecord.hasMoreUL(item) && <div>
                                                               Elenco periodi di presenza c/o l'unità locale:
                                                               <table className="table-fixed w-full ml-8 border-collapse border border-gray-400">
                                                                   <thead className="text-left bg-gray-200">
                                                                   <tr>
                                                                       <th className="w-4/12 border border-gray-300 p-1">#</th>
                                                                       <th className="w-4/12 border border-gray-300 p-1">Decorrenza</th>
                                                                       <th className="w-4/12 border border-gray-300 p-1">Fine</th>
                                                                   </tr>
                                                                   </thead>
                                                                   <tbody>
                                                                   {<tr className="border border-gray-500">
                                                                       <td className="w-4/12 border border-gray-300 p-1">TODO</td>
                                                                       <td className="w-4/12 border border-gray-300 p-1">TODO</td>
                                                                       <td className="w-4/12 border border-gray-300 p-1">TODO</td>
                                                                   </tr>}
                                                                   </tbody>
                                                               </table>
                                                           </div>}*/}
                                                       </td>,
                                                       <td key={'td2_detail_' + item.id}></td>]
                                                   }
                                               </tr>,
                                           ])
                                       }
            />

            <Pagination dataTables={localData} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>
        </>}
    </>
}
